import { render, staticRenderFns } from "./StatisticsMarksByFacultyYearsIndex.vue?vue&type=template&id=2c375e4b"
import script from "./StatisticsMarksByFacultyYearsIndex.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksByFacultyYearsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports